export default {"src":"/_next/static/media/dollar.68e8770d.svg","height":35,"width":42};